// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Nr8T","content":"LayoutSettings_content__3ZQyJ"};